exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flow-container .flow-inner-container{display:flex;justify-content:space-between;margin-left:4em;min-height:100vh}.flow-container .flow-inner-container .tree-view{flex-basis:18em;background:#162e3d;padding:2em 1em 0}.flow-container .flow-inner-container .tree-view .k-treeview{color:#fff}.flow-container .flow-inner-container .graph-container{flex:1}.flow-container .flow-inner-container .graph-container .header{text-align:center;padding:2em}.flow-container .flow-inner-container .graph-container .graph{display:flex;justify-content:center}.flow-container .flow-inner-container .graph-container .graph svg{flex:1}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/app/containers/flow/flow.styl
 ** module id = 897
 ** module chunks = 0
 **/